import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { tradebookModel } from './tradebook.model';
import { DateComponent } from '../../../date/date.component';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { GotxGridComponent } from '../../../gotx/components/gotx-grid/gotx-grid.component';
import { StockComponent } from '../../components/Stock/Stock.component';
import { ProductComponent } from '../../components/Product/Product.component';

const customCss: string = '';

@Component({
  selector: 'app-tradebook',
  templateUrl: './tradebook.component.html'
})
export class tradebookComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
  @ViewChild('dtFromDate', { static: false }) dtFromDate: DateComponent;
  @ViewChild('dtToDate', { static: false }) dtToDate: DateComponent;
  // @ViewChild('stockCombo', {static: false}) stockCombo: GotxComboBoxComponent;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;

  @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
  @ViewChild('gotxGridComp', { static: false }) gotxGridComp: GotxGridComponent;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  skeletonContentLoaded = false;
  productSelected = this.services.dataStore.getproductMasterData();

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.revalidateBasicField('dtFromDate', false, 'dtToDate'),
      this.revalidateBasicField('dtToDate', false, 'dtFromDate'),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  async cstmProduct_productSelected(event) {
    let inputMap = new Map();

    this.reloadStock();
}
  constructor(services: ServiceStock) {
    super(services);
    this.value = new tradebookModel();
    this.componentCode = 'tradebook';
    this.displayBorder = false;
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.dtFromDate.setValue(new Date());
    this.dtToDate.setValue(new Date());
    this.dtFromDate.setFocus(true);

    this.setDependencies();
    this.reloadStock();
   
   this.cstmProduct.cmbProduct.dropDownOptions.Options.push({id: "ALL", text: "ALL"});
   this.cstmProduct.setProductDropDown();

  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'tradebook';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    return this.additionalInfo;
  }
  getFieldValue() {
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.value = new tradebookModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  setProductField(value: string): void {
    this.productSelected = value;
  }

  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'tradebook'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'tradebook_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
    this.setProductField(this.productSelected);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('tradebook_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.onFormLoad();
      this.checkForHTabOverFlow();
      this.btnSubmit_click();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new tradebookModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cmbStock_stockSelected() {
  }
  reloadStock() {
    this.cmbStock.gotxInput.val("");
    let exch = this.services.dataStore.getData("exchangeID");
    //let pdct = this.services.dataStore.getData("productID");
    let pdct = this.cstmProduct.cmbProduct.getFieldValue();
    if (typeof pdct == 'object' ){
      pdct = pdct.text
  }
    let board = "AL";
    this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct, board);
  }


  async btnSubmit_click() {
    let inputMap = new Map();
    // Delete Starts
    // var res = {"respCode":"0","errMsg":null,"response":[
    //   {"symbol":"ABB1STMF##NR#A","exchScripcode":"960001447   ","segment":"DELIVERY","exchange":"CSE","buysell":"SELL","pricetype":null,"filltype":"GFD","exchrefnumber":"EXM1656130838587              ","quantity":null,"disquantity":0,"totalExecutedQTY":null,"price":4.4,"triggerprice":null,"limitprice":0.0,"avgxcutionprice":4.4,"orderrefnumber":"225100G000108     ","brokerage":null,"process":null,"orderstatus":"FILLED","fromdate":null,"todate":null,"datetime":null,"orderqty":6,"pendingqty":0,"executedqty":6,"exchangeLMdate":null,"exchangeLMdateint":20220419,"exchangeLMtime":184000000,"exchangedate":null,"exchangetime":null,"ordersubstatus":" ","event":null,"goTXLMdateint":0,"priceProtection":0.0,"settlementNumber":0,"rejectcode":0,"lostModifiedDate":20220625,"lostModifiedTime":132320542951,"ordertype":"LIMIT","settleMentNumber":20220419,"brokerClientType":"Local-Local","expiryDate":20220625,"settlerid":"            ","settlementnumber":null,"traderefnumber":null,"series":null,"buySymbol":null,"sellSymbol":null,"spreadSymbol":null,"board":null,"contraBrokerId":null,"boardType":"NR","referenceId":"                    ","minFillQty":0,"product":"EQUITY","accruedInterest":0.0,"commission":0.0,"executedValue":null,"yield":0.0,"executedYield":0.0,"reason":null,"tradeID":null,"hiddenSize":0.0,"insDisplayName":" "}],"sessionResponse":null,"target":"success"}
    // var resp = res['response'];
    // resp.forEach(element => {
    //   let exchD: string = element.exchangeLMdateint.toString();
    //   element["exchangedateStr"] = exchD.slice(6, 8).concat("/").concat(exchD.slice(4, 6)).concat("/").concat(exchD.slice(0, 4));
    //   let symbolBoardArr: any[] = element.symbol.split("#");
    //   element.symbol = symbolBoardArr[0];
    // if (this.services.dataStore.getBoardByID(symbolBoardArr[2])[0] != null) {
    //   element.board = this.services.dataStore.getBoardByID(symbolBoardArr[2])[0].text;
    // } else {
    //   element.board = symbolBoardArr[2];
    // }
    // element["exchangetimeStr"] = this.services.timePipe.transform(element.exchangeLMtime);
    // element["exchangetimeStr"] = this.services.timePipe.transform(element.exchangeLMtime);
    //   let lstmddate: string = element.lostModifiedDate.toString();
    //   element["lastModDateStr"] = lstmddate.slice(6, 8).concat("/").concat(lstmddate.slice(4, 6)).concat("/").concat(lstmddate.slice(0, 4));

    //   element["lastModTime"] = this.services.timePipe.transform(element.lostModifiedTime);

    //   element["tradevalue"] = element.orderqty * element.price;
    // });
    // this.gotxGridComp.reloadGrid(resp);
    // Delete Ends
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv').innerHTML = "";
    let productValue = this.cstmProduct.cmbProduct.getFieldValue();
    if (errorCount == 0) {
      inputMap.clear();
      inputMap.set('Body.startdate', this.services.dataStore.dateToDateString((this.dtFromDate.getFieldValue())));

      if (typeof this.cmbStock.gotxInput.val() === 'object') {
        inputMap.set('Body.symbol', this.cmbStock.gotxInput.val().label);
      }
      else {
        inputMap.set('Body.symbol', this.cmbStock.gotxInput.val());
      }

      inputMap.set('Body.exchange', this.services.dataStore.getData("exchangeID"));
      inputMap.set('Body.enddate', this.services.dataStore.dateToDateString((this.dtToDate.getFieldValue())));
     // inputMap.set('Body.selectProduct', this.services.dataStore.getData("productID"));
     inputMap.set('Body.selectProduct', this.cstmProduct.cmbProduct.getFieldValue());
      inputMap.set('Body.clientid', this.services.dataStore.getData("userID"));
      inputMap.set('Body.boardType', "AL");
      if(productValue == "EQUITY"){
        inputMap.set('Body.segment', "DELIVERY");
      }else if(productValue == "COMDERV"){
        inputMap.set('Body.segment', "CARRYFORWARD");
      }
      
      inputMap.set('Body.selectStatus', "ALL");
      this.services.http.fetchApi('/tradebook/history', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          if (respCode != null && respCode == 0) {
            // this.services.alert.showAlert(1, "success", 2000);
            var resp = res['response'];
            resp.forEach(element => {
              let exchD: string = element.exchangeLMdateint.toString();
              element["exchangedateStr"] = exchD.slice(6, 8).concat("/").concat(exchD.slice(4, 6)).concat("/").concat(exchD.slice(0, 4));
              let symbolBoardArr: any[] = element.symbol.split("#");
              element.symbol = symbolBoardArr[0];
              if (this.services.dataStore.getBoardByID(symbolBoardArr[2])[0] != null) {
                element.board = this.services.dataStore.getBoardByID(symbolBoardArr[2])[0].text;
              } else {
                element.board = symbolBoardArr[2];
              }
              let boardValue = this.services.dataStore.getBoardByID(element.boardType); 
              element["boardType"] = boardValue[0].text;
              element["boardTypeId"] = boardValue[0].id;
              element["exchangetimeStr"] = this.services.timePipe.transform(element.exchangetime);
              let lstmddate: string = element.lostModifiedDate.toString();
              element["lastModDateStr"] = lstmddate.slice(6, 8).concat("/").concat(lstmddate.slice(4, 6)).concat("/").concat(lstmddate.slice(0, 4));

              element["lastModTime"] = this.services.timePipe.transform(element.lostModifiedTime);
             
              element["tradevalue"] = element.orderqty * element.price;

             if(element.product ==  2){
              element.product = "COMDERV";
             }else if(element.product ==  13){
              element.product = "FUTOPT";
             }else if(element.product ==  5){
              element.product = "EQUITY";
             }
             console.log("element.product",element.product);
             if(element.product != "EQUITY"){
              console.log("inside derivative count");
                               var fieldSymbol = element.symbol;
                               var fieldexchange = this.services.dataStore.getData("exchangeID");
                               var fieldproduct = element.product;
                               let key = fieldexchange + "#" + fieldproduct + "#NR#" + fieldSymbol;
                               if (this.services.dataStore.stockMasterMap.has(key)) {
                               var StockData = this.services.dataStore.stockMasterMap.get(key);
                               console.log("StockData",StockData);
                               if(element.product == "FUTOPT"){
                                StockData.tradableLotSize = "1";
                               }
                               console.log("StockData2",StockData);
                               console.log("StockData.lotNumerator",StockData.lotNumerator);
                               console.log("StockData.lotDenominator",StockData.lotDenominator);
                               console.log("StockData.priceNumerator",StockData.priceNumerator);
                               console.log("StockData.priceDenominator",StockData.priceDenominator);
                               console.log("StockData.tradableLotSize",StockData.tradableLotSize);
                               element["tradevalue"] = (element.orderqty * element.price)*(StockData.lotNumerator/StockData.lotDenominator)*(StockData.priceNumerator/StockData.priceDenominator)*StockData.tradableLotSize;
                                   }
                                 /*  if(element.product == "FUTOPT"){
                                    StockData.tradableLotSize = "1";
                                   }
                                   console.log("StockData2",StockData);
                                  // console.log("StockData.lotNumerator",StockData.lotNumerator);
                                  // console.log("StockData.lotDenominator",StockData.lotDenominator);
                                  // console.log("StockData.priceNumerator",StockData.priceNumerator);
                                  // console.log("StockData.priceDenominator",StockData.priceDenominator);
                                   element["tradevalue"] = (element.orderqty * element.price)*(StockData.lotNumerator/StockData.lotDenominator)*(StockData.priceNumerator/StockData.priceDenominator)*StockData.tradableLotSize;*/
             }
            });
            this.gotxGridComp.reloadGrid(resp);
          }
          else {
            // this.services.alert.showAlert(2, "failed", -1);
            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	    //commented by Shanmuga Priya - VAPT
            const rawMsg = res['errMsg'];
            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          }
          // this.services.alert.showAlert(2, "error page", -1);
          document.getElementById('errMsgDiv').innerHTML =this.transalte('ErrorCodes.SystemDown');
        }
      );
    }
  }
 /* async btnExport_click() {
    const rows = this.gotxGridComp.gotxGrid.getrows();
    // const columns = Object.keys(rows[0]);  // Get the columns from the grid
    //const columns = this.gotxGridComp.gotxGrid.columns.records;
     //console.log("order book export rows",rows);
     //console.log("order book export columns",columns);
     this.services.dataStore.exportGridFunction(rows,"TradeBook");
  }*/
  async btnExport_click() {
    if (this.gotxGridComp.gotxGrid.getrows().length <= 0) {
      this.services.alert.showAlert(2, "There is No Data to export", 3000);
    } else {
      //this.gotxGridComp.gotxGrid.exportdata('csv', "Trade Book");
      const rows = this.gotxGridComp.gotxGrid.getrows();
   const columns = this.gotxGridComp.gotxGrid.attrColumns;
   this.services.dataStore.exportGridFunction(rows,columns,"TradeBook");
    }
  }
  fieldDependencies = {
  }
  transalte(text) {
    return this.services.translate.instant(text);
  }
  /* Write Custom Scripts Here */
  datafields = [
    { name: 'symbol', type: 'string' },
    { name: 'buysell', type: 'string' },
    { name: 'orderqty', type: 'number' },
    { name: 'price', type: 'number' },
    { name: 'tradevalue', type: 'number' },
    { name: 'exchangetradenumber', type: 'string' },
    { name: 'traderefnumber', type: 'string' },
    { name: 'exchangetimeStr', type: 'string' },
    { name: 'orderrefnumber', type: 'string' },
    { name: 'exchange', type: 'string' },
    { name: 'exchrefnumber', type: 'string' },
    { name: 'gotxtradenumber', type: 'string' },
    { name: 'lastModTime', type: 'string' },
    { name: 'lastModDateStr', type: 'string' },
    { name: 'exchangedateStr', type: 'string' },
    { name: 'board', type: 'string' },
    { name: 'limitprice', type: 'number' },
    { name: 'boardType', type: 'number' },
    { name: 'product', type: 'string' }

    
  ];

  rowId = "gotxtradenumber";
  datatype = "json";
  columns: any[] = [
    { text: this.transalte('tradebook.StockCode'), datafield: 'symbol', width: 230,align: 'center' },
    { text: this.transalte('tradebook.BuySell'), datafield: 'buysell', width: 100 ,align: 'center'},  
    { text: this.transalte('tradebook.ExecutedQty'), datafield: 'orderqty', width: 100, cellsformat: 'n',align: 'center' },
    { text: this.transalte('tradebook.TradePrice'), datafield: 'price', width: 100, cellsformat: 'f2',align: 'center' },
    { text: this.transalte('tradebook.TradeValue'), datafield: 'tradevalue', width: 100, cellsformat: 'f2',align: 'center' },
    { text: this.transalte('tradebook.ExchTradeRefNo'), datafield: 'exchangetradenumber', width: 120,align: 'center'  },
    { text: this.transalte('tradebook.ExchangeTime'), datafield: 'exchangetimeStr', width: 100,align: 'center' },
    { text: this.transalte('tradebook.IPMSOMSOrderRefNo'), datafield: 'orderrefnumber', width: 140 ,align: 'center'},
    { text: this.transalte('tradebook.Exch'), datafield: 'exchange', width: 100,align: 'center' },
    { text: this.transalte('tradebook.ExchRefNo'), datafield: 'exchrefnumber', width: 120,align: 'center' },
    { text: this.transalte('tradebook.IPMSTradeRefNo'), datafield: 'gotxtradenumber',align: 'center' },
    { text: this.transalte('tradebook.IPMSOMSTime'), datafield: 'lastModTime', width: 100,align: 'center' },
    { text: this.transalte('tradebook.IPMSOMSDate'), datafield: 'lastModDateStr', width: 100,align: 'center' },
    { text: this.transalte('tradebook.ExchangeDate'), datafield: 'exchangedateStr', width: 100,align: 'center' },
    { text: this.transalte('tradebook.Board'), datafield: 'boardType', width: 100, cellsalign: 'left',align: 'center' },
    { text: this.transalte('tradebook.Product'), datafield: 'product', width: 100, cellsalign: 'left',align: 'center' }
    // { text: this.transalte('tradebook.TriggerPrice'), datafield: 'limitprice', width: 100, cellsformat: 'f2',align: 'center' }
  ];

  data = [];
}